import { defineStore } from 'pinia';

export const useBulkImportStore = defineStore({
  id: 'bulkImport',
  state: () => {
    if (localStorage.getItem('tableData')) {
      return { tableData: JSON.parse(localStorage.getItem('tableData')) };
    }
    return {
      tableData: [],
    };
  },
  actions: {
    reset() {
      this.tableData = [];
    }
  },
});
